import axios from 'axios';
import { MarketId } from 'types/market-id.enum';
import { OrderMaintenance } from 'views/order-feed/types/order-maintenance.type';

// GET
// /ewosapi/v1/order/settings
export const getOrderSettings = async (marketId: MarketId): Promise<OrderMaintenance> => {
  const res = await axios.get<OrderMaintenance>(`/ewosapi/v1/order/maintenance?marketId=${marketId}`);
  return res.data;
};
